import classNames from "classnames";
import React from "react";
import { withRouter } from "react-router-dom";
import mainCss from "../style.scss";
import css from "./style.scss";
import CreateTeamProfile from "./createTeamProfile";
import ReviewTeam from "./reviewTeam";
import SuccessTeamProfile from "./successTeamProfile";
import MultiStepForm from "components/MultiStepForm";
import FormStep from "components/MultiStepForm/FormStep";
import { FormProvider } from "../../../context/FormContext";
import {profileValidationSchema, reviewTeamValidationSchema } from "./validationSchemas";
import { connect, useDispatch, useSelector } from "react-redux";
import LeaveMessagePopup from "../modals/LeaveMessage";
import { selectSelectedTeamMember  , selectTeamMembers , selectUserId } from "data/user/selectors";
import { upgradeFullAccessTeamMemberAPI } from "../../../data/user";
import { useEffect } from "react";
import { selectedTeamMember } from "data/user/actions";

const ReviewTeamMemberProfile = ({history,leaveMessagePopup}) => {

  const dispatch = useDispatch();
  const userID = useSelector(selectUserId)
const selectedMember = useSelector(selectSelectedTeamMember)?.toJS();
const allTeamMembers = useSelector(selectTeamMembers);
const pathParts = history?.location?.pathname?.split('/');
const memberId = pathParts?.[pathParts.length - 1];
const fallbackMember = allTeamMembers?.find(
  m => m?.userId?.toString() === memberId?.toString()
);

useEffect(() => {
  if (!selectedMember?.userId && fallbackMember?.userId) {
    dispatch(selectedTeamMember(fallbackMember));
  }
}, [selectedMember, fallbackMember, dispatch]);
const teamMemberDetails =  selectedMember?.userId ?  selectedMember :  fallbackMember;  

  const steps = [
    {
      component: (
        <FormStep defaultValues={teamMemberDetails}  CancelButtonLabel="Cancel" showCancelButton={true} >
          <CreateTeamProfile review={true} />
        </FormStep>
      ),
      validationSchema: profileValidationSchema,
      initialValues: teamMemberDetails,
      screen: '1'
    },
    {
      component: (
        <FormStep  backButtonLabel="Back to Profile" continueButtonLabel={"Confirm Changes"}>
          <ReviewTeam review={true} />
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isSubmissionStep: true, // No validation for review step
      screen: '2'
    },
    {
      component: (
        <FormStep continueButtonLabel="Return to Account Home" showBackButton={false} >
          <SuccessTeamProfile review={true}/>
        </FormStep>
      ),
      validationSchema: reviewTeamValidationSchema,
      isRedirectStep: true,
      screen: '3'
    },
  ];

  const handleNextStep = (formData, nextStep, currentStep) => {
    if (
      formData?.type !== "SCOUT" && 
      currentStep?.screen === "1" &&  
      (!formData?.spendingLimit || !formData?.propertyLimit)
    ) {
      leaveMessagePopup({
        title : 'Are you sure want to proceed?',
       message : 'without setting usage limits , This will allow unlimited usage.',
        CancelRedirect: () => null, // Stay on the same step
        yesRedirect: () => nextStep(), // Move to the next step
      });
      return; // Prevent navigation until the user selects an option
    }

    if(typeof nextStep === "function") {
      nextStep(); // Move to the next step if no popup is needed    
    }
  };


  const handleSubmit = async (finalData) => {
    try {
      const upgradePaylaod = {
        primaryUserId: Number(userID),  // getting from profile store
        teamMemberId: Number(memberId), // getting from url
        type: 'TEAM_FULL', // always
        amount: 30, // // always 30 need to sent what we are doing in create full team  finalData?.spendingLimit
        defaultSubsPaymentMethodId: finalData?.defaultSubsPaymentMethodId,
        defaultInAppPaymentMethodId: finalData?.defaultInAppPaymentMethodId,
      }
      const response = await upgradeFullAccessTeamMemberAPI(upgradePaylaod);
      if (response.success) {
        // setDueAmount(response.data?.dueAmount); // no need this code we are not using this
      } else {
        leaveMessagePopup({
          title: "Error",
          message: error?.message,
          yesLable: 'Close',
          cancelLable: '',
          yesRedirect: () => null,
        });
      }
    } catch (error) {
      leaveMessagePopup({
        title: "Error",
        message: error?.message,
        yesLable: 'Close',
        cancelLable: '',
        yesRedirect: () => null,
      });
      throw error;
    }
  };

  const handleCancel = () => {
    console.log("Cancel button clicked!");
    leaveMessagePopup({
      CancelRedirect: () => null, 
      yesRedirect: () =>  history.push("/accountnew/landing"),
    });
    // Add any logic to handle the cancel action (e.g., navigate back, reset form, etc.)
  };


  return (
    <div className={mainCss.clsInnerMainBody}>
      <div>
      {teamMemberDetails?.userId ? (
        <FormProvider>
          <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={handleCancel} history={history} redirectPath="/accountnew/landing" 
          onNext={handleNextStep}
          />
        </FormProvider>
        ) : (
          <div className={css.loadingWrapper}>Loading details...</div>
        )}
      </div>
    </div>
  );
};


export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open
})(ReviewTeamMemberProfile));